import React from 'react';
import { View, Text, Image, TouchableOpacity, Alert } from 'react-native';

import { onFileRead } from "../../helpers/onFileRead";

import Colors from "../../constants/Colors";

const imagePickerOptions = {
	title: 'Escolher Imagem',
	maxWidth: 1080,
	maxHeight: 1920,
	storageOptions: {
		skipBackup: true,
		path: 'images',
	},
};

const ImageSelector = (props) => {

	const { image, onImageChange, onImageRemove, index, displaySize } = props;

	const { width, height } = displaySize ? displaySize : { width: 60, height: 60 };

	if (image === null) {
		return (
			<View style={{ marginRight: 10, width: 60, height: 120, justifyContent: 'center', alignItems: 'center' }}>
				<label htmlFor='invisibleInput'>
					<TouchableOpacity>
						<input
							type='file'
							id='invisibleInput'
							onChange={ e => onFileRead(e, onImageChange)}
							accept='image/png, image/jpeg'
							style={{ display: 'none' }}
						/>

						<View style={{ width: 60, height: 60, backgroundColor: Colors.buttonColor, borderRadius: 8, justifyContent: 'center', alignItems: 'center'  }}>
							<Image
								source={require('../../img/icons/CameraIcon.png')}
								style={{ width: 40, height: 40}}
								resizeMode={'contain'}
							/>
						</View>
						<Text style={{ marginTop: 10, fontSize: 12, fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
							Adicionar imagem
						</Text>

					</TouchableOpacity>
				</label>
			</View>
		)
	}

	const imageData = 'data:image/jpeg;base64,' + image;

	return (
		<View style={{ marginRight: 10, width: 60, height: 120, justifyContent: 'center', alignItems: 'center' }}>
			<TouchableOpacity 
				style={{ width: 60, height: 60, borderRadius: 8, justifyContent: 'center', alignItems: 'center' }}
				onPress={onImageRemove}
			>
				<Image
					source={{ uri: imageData }}
					style={{ width: width, height: height, borderRadius: 8 }}
					resizeMode={'cover'}
				/>
				<Text style={{ marginTop: 10, fontSize: 12, fontWeight: 'bold', color: 'white', textAlign: 'center' }}>
					Remover imagem
				</Text>
			</TouchableOpacity>
		</View>
	)
}

export default ImageSelector;
